export const environment = {
	production: false,
	webStorageUrl: 'https://ssiwebstorageqa.blob.core.windows.net',
	apiBaseURL: 'https://rr-wus3-pubweb-api-radiusauto-qa-ezdhecfdcrbcawek.westus3-01.azurewebsites.net'
}